<template>
  <input type="checkbox" :id="letter.value" :checked="letter.active" />
  <label :for="letter.value">{{ letter.value }}</label>
</template>

<script>
export default {
  props: {
    letter: {
      type: Object,
      required: true,
    },
  },
  setup() {},
};
</script>

<style lang="scss">
input:where([type="checkbox"]) {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);

  &:not(:checked) {
    + label {
      border-color: var(--color-shade-dark-glare);
      opacity: 0.35;
    }
  }

  &:checked {
    + label {
      border-color: var(--color-state-good);
    }
  }

  + label {
    display: grid;
    border: 2px solid var(--color-shade-dark);
    border-radius: var(--radius-medium);
    place-content: center;
    aspect-ratio: 1;
    text-transform: uppercase;
    transition: transform 50ms ease-out, box-shadow 50ms ease-out;
    transform-origin: center;

    &:hover,
    &:focus {
      box-shadow: 0px 2px 4px hsla(var(--shade-dark-hsl), 0.3);
      transform: scale(1.05);
    }
  }
}
</style>
